// Styling map for the Cash Flow report grid (EVA-274).
//
// Renderers are injected rather than imported so this module stays free of
// Handsontable and the DOM, and can be exercised under bare node.

export const KIND_CLASS = {
  header_year: 'cfr-h-year',
  header_period: 'cfr-h-period',
  section: 'cfr-section',
  major: 'cfr-major',
  minor: 'cfr-minor',
  tenant: 'cfr-tenant'
}

// Handsontable shallow-MERGES this return value into a persistent per-cell meta
// store, so an omitted key keeps whatever a previous render left on the recycled
// cell. Every branch therefore returns every key it can ever set — '' rather than
// undefined for "no class". (CashFlowTable.jsx:655 returns a bare
// `{ readOnly: true }`, which is how a stale indent class survives a toggle.)
export function cellMeta(row, col, { textRenderer, expanderRenderer }) {
  if (!row) {
    return { readOnly: true, className: '', renderer: textRenderer, cfrKey: null, cfrExpanded: false }
  }

  const labelCol = col === 0

  return {
    readOnly: true,
    className: [
      KIND_CLASS[row.kind] || '',
      // htMiddle on both columns: Handsontable's td defaults to vertical-align:top,
      // so without it the label sits at the top of the row while the numbers are
      // centred — visible on every row, glaring on the taller section rows.
      labelCol ? `cfr-label htMiddle cfr-depth-${row.depth || 0}` : 'htRight htMiddle',
      row.rule && row.rule !== 'none' ? `cfr-rule-${row.rule}` : '',
      row.bold ? 'cfr-bold' : ''
    ].filter(Boolean).join(' '),
    renderer: labelCol && row.expandable ? expanderRenderer : textRenderer,
    cfrKey: row.key,
    cfrExpanded: row.expanded === true
  }
}

// §3: "modest spacing above the section". Fixed heights are load-bearing rather
// than cosmetic — the horizon theme's td height budget has no slack, so a row
// that grows by a border would trigger oversized-row re-measurement.
export const ROW_HEIGHT = 36
export const SECTION_ROW_HEIGHT = 52

export function rowHeight(row) {
  return row?.kind === 'section' ? SECTION_ROW_HEIGHT : ROW_HEIGHT
}
